import DiscountRelationQueries from './DiscountRelationQueries'

const viewDiscountRelationsCachesReport = {
  viewDiscountRelationsCachesReport: {
    ...DiscountRelationQueries,
  }
}

export default viewDiscountRelationsCachesReport